import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../../shared/services/auth.service";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {Router, RouterLink} from "@angular/router";
import {AsyncPipe, NgIf} from '@angular/common';
import {firstValueFrom} from "rxjs";
import {WarningMessageComponent} from "../../../shared/components/messages/warning-message/warning-message.component";
import {SocialSigninButtonComponent} from "../../../shared/components/auth/social-signin-button/social-signin-button.component";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [NgIf, RouterLink, FormsModule, ReactiveFormsModule, AsyncPipe, WarningMessageComponent, SocialSigninButtonComponent]
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup
  processing = false
  constructor(
    public authSvc: AuthService,
    private router: Router
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.email, Validators.required]),
      password: new FormControl('', Validators.required)
    })
  }

  get email() { return this.loginForm.get('email') as FormControl }
  get password() { return this.loginForm.get('password') as FormControl }
  ngOnInit(): void {
  }

  onLogin() {
    this.loginForm.markAllAsTouched()
    this.authSvc.resetErrors()
    if (this.loginForm.invalid) { return }
    this.processing = true
    this.authSvc.loginWithEmail(this.loginForm.get('email')?.value, this.loginForm.get('password')?.value)
      .then(async () => {
        // await this.router.navigate(['/']);
      })
      .catch((err) => {
        this.authSvc.errorSelector(err)
        this.processing = false
      });
  }

  async continue() {
    if (this.authSvc.auth.currentUser?.emailVerified) {
      const user = await firstValueFrom(this.authSvc.userData$)
      if (!user) {
        await this.router.navigate(['/auth/login']);
      } else {
        if (user.onBoarded) {
          await this.router.navigate(['/']);
        } else {
          await this.router.navigate(['/on-boarding']);
        }
      }
    } else {
      await this.router.navigate(['/auth/validate-email']);
    }
  }

}
